export enum ResultTextType {
  COMPATIBILITY = 'COMPATIBILITY',
  LINKEDIN = 'LINKEDIN',
  REVISION = 'REVISION',
  SALESTEXT = 'SALESTEXT',
  WHATWHY = 'WHATWHY',
}
